import React, { useState } from 'react';

//codemirror imports
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { thriveCodeMirrorTheme } from './utilities';

//styling
import '../../../../css/global/CodeMirror.scss';



const CodeMirrorInput = ({inputPlaceholderText, inputValue, setInputValue, maxLength, limitReachedMessage, setDisableUpload, isDctEnabled}: {inputPlaceholderText?: string, inputValue?: string, setInputValue: any, maxLength: number, limitReachedMessage: string, setDisableUpload: any, isDctEnabled: boolean}) => {
    
    const [showLimitMessage, setShowLimitMessage]=useState<boolean>(false);

    const handleInputChange = (input: any) => {
        // Ensure that the input value doesn't exceed max length characters
        
        setInputValue(input);

        if (input.length > 1) {
            setDisableUpload(false);
        } else {
            setDisableUpload(true);
        }



        if (isDctEnabled && (input.replace(/<[^>]*>/g, '').length > maxLength)) {
            setShowLimitMessage(true);
        } else {
            setShowLimitMessage(false);
        }
    };

    return (
        <>
        <div className={`code-mirror-container ${showLimitMessage && "error-border"}`}>
            <CodeMirror className='code-mirror-input' theme={thriveCodeMirrorTheme} extensions={[html()]} value={inputValue} onChange={handleInputChange} placeholder={inputPlaceholderText} width={'595px'} max-width={'595px'} height= {'391px'} basicSetup tabIndex={0}/>
        </div>

        {showLimitMessage 
        ?   <span aria-live="polite" className='limit-error'>{limitReachedMessage}</span>
        :   <div className='spacer'/>
        }
        </>
    )
}
export default CodeMirrorInput;